import React from 'react';
import { Input } from 'antd';
const Search = Input.Search;
import styles from './index.scss'
export default class WWSearch extends React.Component{
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <Search style={{height:30}} className={styles.gps_input} {...this.props}/>
        )
    }
}